import React from 'react';
import { BrowserRouter, Navigate, useLocation } from 'react-router';

import { LayoutAdmin } from '@/components/layout/admin';

/**
 * AI.GEN lines=1-18
 * 路由根组件 - / 声明式重定向到派单工作台
 */
const LayoutRoot = () => {
  const location = useLocation();

  if (location.pathname === '/') {
    return <Navigate to="/dispatch-workbench" replace />;
  }

  return <LayoutAdmin />;
};

export const Router = () => {
  return (
    <BrowserRouter basename={'/'}>
      <LayoutRoot></LayoutRoot>
    </BrowserRouter>
  );
};
